class DropDown extends HTMLDetailsElement {
  constructor() {
    super();
    this._onEnter = this._onEnter.bind(this);
    this._onLeave = this._onLeave.bind(this);
    this._onClick = this._onClick.bind(this);
  }

  connectedCallback() {
    // cache refs
    this.trigger = this.dataset.trigger || 'click'; // 'hover' | 'click'
    this.summary = this.querySelector('summary');
    if (!this.summary) return; // nothing to do

    this.content = this.summary.nextElementSibling;
    
    // For hover mode, attach events to the parent container if it exists
    this.hoverContainer = this.closest('.header__menu-item-with-dropdown') || this;

    // baseline: allow native toggle via click unless we do hover-mode
    if (this.trigger === 'hover') {
      // Prevent native toggle on click if using hover trigger
      this.summary.addEventListener('click', this._onClick);
      this.hoverContainer.addEventListener('mouseenter', this._onEnter);
      this.hoverContainer.addEventListener('mouseleave', this._onLeave);
      // optional: keyboard escape to close
      this.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') this.open = false;
      });
    } else {
      // click mode: native <details> toggle works;
      // add Esc to close for a11y parity
      this.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') this.open = false;
      });
    }
  }

  disconnectedCallback() {
    if (!this.summary) return;
    this.summary.removeEventListener('click', this._onClick);
    if (this.hoverContainer) {
      this.hoverContainer.removeEventListener('mouseenter', this._onEnter);
      this.hoverContainer.removeEventListener('mouseleave', this._onLeave);
    } else {
      this.removeEventListener('mouseenter', this._onEnter);
      this.removeEventListener('mouseleave', this._onLeave);
    }
  }

  // Handlers
  _onEnter() { this.open = true; }
  _onLeave() { this.open = false; }
  _onClick(e) {
    // In hover mode, block native toggle so hover controls state
    e.preventDefault();
    e.stopPropagation();
  }
}

// Register: custom built-in element (note the hyphen)
customElements.define('dropdown-details', DropDown, { extends: 'details' });
